export function getTimezoneOffset() {
  const now = new Date();
  const offsetInMinutes = -now.getTimezoneOffset();
  const offsetInHours = offsetInMinutes / 60;
  const sign = offsetInHours >= 0 ? '+' : '-';
  const absoluteOffset = Math.abs(offsetInHours);
  const hours = String(Math.floor(absoluteOffset)).padStart(2, '0');
  const minutes = String(Math.floor((absoluteOffset % 1) * 60)).padStart(
    2,
    '0',
  );

  return `${sign}${hours}:${minutes}`;
}
